/*
 *   File : text-area.js
 *   Author : https://evoqins.com
 *   Description : Text area component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';

//custom style
import style from "../../Style/Component/textarea.module.scss";

const CustomTextArea = (props) => {

    const [isTextareaFocused, setIsTextareaFocused] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsTextareaFocused(true);
    };

    const _handleBlur = () => {
        setIsTextareaFocused(false);
    };

    //Textarea handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        props.handleChange(value);
    };


    return (
        <div className={props.wrapperClass} ref={props.ref} >
            {props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`${style.e_textarea_wrapper} position-relative`}>
                <div className={` ${props.error && style.e_error_border} ${isTextareaFocused ? `${style.e_active} ` : `${style.e_inactive} ${props.borderStyle} `} border-radius-8`}>
                    <textarea id={props.id}
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type={props.type}
                        rows={props.rows ? props.rows : 3}
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_textarea} ${props.className} e-primary-font p-3 border-0 border-radius-8 e-bg-white e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onClick={props.onClick} />
                </div>

                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

CustomTextArea.defaultProps = {
    onKeyPress: () => { },
    onChange: () => { },
    className: null,
    error: "",
    value: "",
}



export default memo(CustomTextArea);